import React, { Component } from 'react'
import IconSwiggle from '../../../images/ico-swiggle.svg'
import IconBrush from '../../../images/ico-brush-animated.png'
import Social from '../../../components/social'

class ArtistHeader extends Component {
  render() {
    const { acf, slug, profile_image, specialty, availability } = this.props
    const { facebook_id, instagram_id } = acf

    let nameEl
    let profileImageEl
    let specialtyEl
    let availabilityEl

    if (slug) {
      nameEl = <h1 className="artist-header__name">{ slug }</h1>
    }

    if (profile_image) {
      profileImageEl = <div className="col col--sm-2">
                          <div className="artist-header__img-wrapper">
                             <img
                                 src={ profile_image.sizes.medium }
                                 alt={ slug + "'s profile image"} className="artist-header__profile-image" />
                          </div>
                       </div>
    }

    if (specialty) {
      specialtyEl = <div className="artist-header__services">
                    <img
                          src={ IconBrush }
                          alt="brush icon" className="artist-header__services-ico"/>
                    <span>{ specialty }</span>
                  </div>
    }

    if (availability) {
      availabilityEl = <span className="artist__availability">{ availability }</span>
    }

    return (
      <div className="artist-header row">
        { profileImageEl }
        <div className="artist-header__content col col--sm-8">
          { nameEl }
          { specialtyEl }
          <div className="artist-header__social">
            <span>follow me on</span>
            <img className="artist-header__social-ico" src={ IconSwiggle } alt="icon swiggle"/>
            <Social instagram={ instagram_id } facebook={ facebook_id } />
          </div>
          { availabilityEl }
        </div>
      </div>
    );
  }
}

export default ArtistHeader;



// WEBPACK FOOTER //
// ./src/components/headers/artist/index.js